import { Component, ElementRef, forwardRef, Input, OnInit, Renderer2 } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'tcat-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectComponent),
      multi: true
    }
  ]
})
export class SelectComponent implements OnInit {

  constructor(private element: ElementRef, private renderer: Renderer2) { }

  get value() {
    return this._value;
  }

  @Input()
  disabled = false;

  @Input()
  noLabel = false;

  @Input()
  set value(val) {
    this._value = val;
    this.onChange(val);
    this.onTouched();
  }

  @Input()
  tabindex: number = 0;

  @Input()
  values: any = [];

  @Input()
  config: { key: string, description: string } = defaultConfig;

  @Input()
  placeholder: string = '';

  @Input()
  selectedValue: string = '';


  _value?: string = undefined;

  onChange: any = () => { };
  onTouched: any = () => { };

  ngOnInit() {
    if (this.selectedValue != null) {
      this._value = this.selectedValue;
    } else {
      this._value = undefined;
    }
  }

  setDisabledState(isDisabled: boolean) {
    this.renderer.setProperty(this.element.nativeElement.querySelector('select'), 'disabled', isDisabled);
  }


  writeValue(val: any): void {
    if (val) {
      this.value = val;
    } else {
      this.value = '';
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

}

const defaultConfig = { key: 'id', description: 'description' };
